export default __webpack_public_path__ + "static/media/edited-10.d44b52c7.jpg";